import { Flex } from 'front-commons/ds';
import styled from 'styled-components';

export const SuggestedProductCardContainer = styled(Flex)``;
